import { AxiosInstance } from 'axios';
import { getWithAuth } from '../InitializeService';

export const getDistinctInsuranceCompanies = (region: string, instance: AxiosInstance) => {
    return getWithAuth(
        `insurance-companies/by-region/${encodeURIComponent(region)}?$select=Title&$orderby=Title asc`,
        instance
    );
};
